import { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import api from "@/lib/api";

const money = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Aviso latente de pedidos pendientes de pago (franquicias y Almacén Oaxaca). */
export default function AdeudosBanner() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/traspasos/adeudos").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d || !d.pedidos.length) return null;
  const pend = d.pedidos.filter((p) => p.pago_estado !== "por_conciliar");
  return (
    <div className="rounded-2xl border-2 border-rose-300 bg-rose-50 p-4 mb-3" data-testid="adeudos-banner">
      <div className="flex flex-wrap items-center gap-2 font-display font-bold text-rose-800 text-sm"><CreditCard className="w-4 h-4" /> Pedidos pendientes de pago: <span className="font-mono" data-testid="adeudos-total">{money(d.total_pendiente)}</span>{d.por_conciliar > 0 && <span className="chip chip-amber text-[10px]">{money(d.por_conciliar)} con comprobante, por conciliar</span>}</div>
      <div className="flex flex-wrap gap-1.5 mt-2">{pend.map((p) => <span key={p.id} className="chip chip-red font-mono text-[10px]" data-testid={`adeudo-${p.folio}`}>{p.folio} · {p.destino_nombre} · {money(p.subtotal)}</span>)}</div>
      <p className="text-[11px] text-rose-700 mt-2">Abre el pedido y adjunta el comprobante de pago; Tesorería lo conciliará.</p>
    </div>
  );
}
